import React, { Component } from 'react';
import './register.css';
import RegisterForm from './registerForm';
import { connect } from 'react-redux';
import { searchCityByTerm, searchCountyByTerm } from '../../../SHARED/actions/geolocation.actions';
import {requestRegister} from '../../actions/user.actions';
import {withRouter} from 'react-router';
import moment from 'moment';
import { pageViewEvent } from '../../helpers/general.helper';
import { Helmet } from 'react-helmet';

const months = [
    'Ianuarie', 'Februarie', 'Martie', 'Aprilie',
    'Mai', 'Iunie', 'Iulie', 'August',
    'Septembrie', 'Octombrie', 'Noiembrie', 'Decembrie'
];

class Register extends Component {

    componentWillMount(){
        window.scrollTo(0, 0);
    }
    
    componentDidMount(){
        pageViewEvent('Înregistrare - Cinemap','/inregistrare')
    }

    getMonths = () => {
        return months.map((month, index) => (
            <option key={index} value={index + 1}>{month}</option>
        ));
    };

    getDays = () => {
        let days = [];
        for (let i = 1; i <= 31; i++) {
            days.push(i);
        }
        return days.map((day, index) => (
            <option key={index} value={day}>{day}</option>
        ));
    };

    getDropdownValues = (min, max) => {
        let numbers = [];
        for (let i = min; i <= max; i++) {
            numbers.push(i);
        }

        return numbers.map((number, index) => (
            <option key={index} value={number}>{number}</option>
        ));
    };

    register = data => {
        const user = {
            first_name: data.firstName,
            last_name: data.lastName,
            email: data.email,
            password: data.password,
            date_of_birth: moment(`${data.year}-${data.month}-${data.day}`).format("YYYY-MM-DD")
        }
        this.props.requestRegister(user);
    }

    render(){
        return (
            <div>
                <Helmet>
                    <title>Înregistrare - Cinemap</title>
                    <meta name="description" content="Creează-ti un cont nou, intră în clubul Cinemap și descoperă toate avantajele de care se bucură un user autentificat!"/>
                    <link rel="canonical" href={window.location.href}/>
                </Helmet>
                <RegisterForm
                    onSubmit={this.register}
                    getDropdownValues={this.getDropdownValues}
                    getMonths={this.getMonths}
                    getDays={this.getDays}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    // cities: state.geolocation.cities,
    // counties: state.geolocation.counties
});
export default withRouter(connect(mapStateToProps, {searchCityByTerm, searchCountyByTerm, requestRegister})(Register));



// WEBPACK FOOTER //
// ./src/SHARED/components/register/register.component.js